/**
 * Get the filtered data
 * @param data The data set
 * @param filterBy The value to filter by
 * @param columns The columns
 */
export const getFilteredData = (data, filterBy, columns) => {
  return data.filter(item => {
    return columns.some(c => {
      return c.dataIndex && item[c.dataIndex] ? item[c.dataIndex].toString().toLowerCase().includes(filterBy.toLowerCase()) : false;
    });
  });
};